import * as React from "react";
const Instagram = (props) => (
  <svg
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="w-[48px] h-[48px] lg:w-[56px] lg:h-[56px] group"
  >
    <circle
      cx="28"
      cy="28"
      r="27.5"
      stroke="#1F2022"
      className="group-hover:fill-primary"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M37.438 21.446c.296.786.453 1.617.464 2.457.062 1.056.063 1.402.065 4.076v.037c0 2.708-.015 3.046-.062 4.113a7.301 7.301 0 0 1-.465 2.425 5.118 5.118 0 0 1-2.92 2.92 7.306 7.306 0 0 1-2.423.464C31.038 38 30.69 38 27.983 38s-3.045-.014-4.113-.062a7.3 7.3 0 0 1-2.423-.499 5.11 5.11 0 0 1-2.92-2.918 7.312 7.312 0 0 1-.465-2.425C18 31.036 18 30.69 18 27.982c0-2.707.014-3.046.062-4.113a7.267 7.267 0 0 1 .465-2.423 5.107 5.107 0 0 1 2.92-2.92 7.323 7.323 0 0 1 2.422-.465C24.928 18 25.275 18 27.982 18c2.708 0 3.046.013 4.113.061a7.325 7.325 0 0 1 2.424.466 5.11 5.11 0 0 1 2.919 2.92Zm-14.588 6.53a5.125 5.125 0 1 0 10.252 0 5.126 5.126 0 0 0-10.252 0Zm9.998-4.21a1.194 1.194 0 1 0 .915-2.207 1.194 1.194 0 0 0-.915 2.207Zm-1.545 4.21a3.33 3.33 0 1 1-6.66 0 3.33 3.33 0 0 1 6.66 0Z"
      fill="#1F2022"
      className="group-hover:fill-white"
    />
  </svg>
);
export default Instagram;
